import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Button as AntdButton, Flex, } from 'antd';
import { useSelector } from 'react-redux';
import Icon from '../../../../../components/common/Icon';
import { LeftPanel, LeftPanelCard, LeftPanelCardBody, LeftPanelCardHead, LeftPanelContainer, PanelSearch, } from '../../../editor.style';
import AlphabetList from '../../../../../components/common/AlphabetList';
const MappedThreeDObjectListPanel = ({ isOpen, onBack, onSelect }) => {
    const [searchKey, setSearchKey] = useState();
    const mapObjectProperties = useSelector((state) => state?.mapObject?.getMapObjectProperties?.response?.content);
    return (_jsx(_Fragment, { children: _jsx(LeftPanel, { style: {
                width: '320px',
            }, isOpen: isOpen, children: _jsx(LeftPanelContainer, { children: _jsxs(LeftPanelCard, { children: [_jsxs(LeftPanelCardHead, { children: [_jsxs(Flex, { align: "center", style: { marginBottom: 10 }, children: [_jsx("h3", { children: "Mapped 3D Objects" }), _jsx(AntdButton, { color: "primary", variant: "text", icon: _jsx(Icon, { icon: "plus-circle" }), onClick: () => {
                                                onBack();
                                            } })] }), _jsx(Flex, { align: "center", gap: 12, children: _jsx(PanelSearch, { placeholder: "Search Locations", variant: "filled", allowClear: true, prefix: _jsx(Icon, { icon: "search-md", size: 16 }), onChange: (e) => {
                                            setSearchKey(e.target.value);
                                        } }) })] }), _jsx(LeftPanelCardBody, { children: _jsx(AlphabetList, { hideCheckbox: true, searchKey: searchKey, onSelect: (id) => {
                                    if (Array?.isArray(mapObjectProperties)) {
                                        const property = mapObjectProperties?.find(it => it.id === id);
                                        onSelect(property);
                                    }
                                }, onDelete: (id) => {
                                    //   onSelect(id);
                                },
                                // data={(mapObjectProperties || [])?.map((it) => ({
                                //   name: it.name,
                                //   id: it.id
                                // }))}
                                data: Array.isArray(mapObjectProperties) ? mapObjectProperties?.map((item) => ({
                                    name: item?.name,
                                    id: item?.id
                                })) : [] }) })] }) }) }) }));
};
export default React.memo(MappedThreeDObjectListPanel);
